import urls from './restConstants';
import api from './restApi';

const newsCollection = api.all(urls.news);


export default newsCollection;



// WEBPACK FOOTER //
// ./shared/src/rest/newsRest.js